// function autoSelectColor() {
//   const activeFilters = Array.from(
//     document.querySelectorAll('.filter-item.filter-item--active[data-group="COLOR"]')
//   );

//   // Only run if exactly one color filter is selected
//   if (activeFilters.length !== 1) return;

//   const selectedColor = (
//     activeFilters[0].dataset.swatchTooltip ||
//     activeFilters[0].dataset.handle.replace('color_', '')
//   ).toLowerCase().trim();

//   document.querySelectorAll('.productgrid--item').forEach(card => {
//     const container = card.querySelector('[data-swatches-container]');
//     if (!container) return;

//     const swatches = container.querySelectorAll('input[name="swatch"]');
//     let matchedSwatch = null;

//     swatches.forEach(input => {
//       const swatchColor = input.value.toLowerCase().trim();
//       const isMatch =
//         swatchColor === selectedColor ||
//         swatchColor.includes(selectedColor) ||
//         selectedColor.includes(swatchColor);

//       if (isMatch) matchedSwatch = input;
//     });

//     if (matchedSwatch) {
//         const swatchWrapper = matchedSwatch.parentElement.parentElement;
//         swatchWrapper.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
//         setTimeout(() => {
//             matchedSwatch.dispatchEvent(new MouseEvent('click', { bubbles: true }));
//             matchedSwatch.dispatchEvent(new Event('change', { bubbles: true }));
//            swatchWrapper.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
//         }, 150);
//     }
//   });
// }

function autoSelectColor() {
  const activeFilters = Array.from(
    document.querySelectorAll('.filter-item.filter-item--active[data-group="COLOR"]')
  );

  if (activeFilters.length !== 1) return;

  const selectedColor = (
    activeFilters[0].dataset.swatchTooltip ||
    activeFilters[0].dataset.handle.replace('color_', '')
  ).toLowerCase().trim();

    document.querySelectorAll('.productgrid--item').forEach(card => {
        const container = card.querySelector('[data-swatches-container]');
        if (!container) return;

        const inputs = Array.from(container.querySelectorAll('input[name="swatch"]'));
        const matchedInput = inputs.find(input => {
        const swatchColor = (input.value || '').toLowerCase().trim();
        return (
            swatchColor === selectedColor ||
            swatchColor.includes(selectedColor) ||
            selectedColor.includes(swatchColor)
        );
        });

        if (!matchedInput) return;

        const swatchWrapper = matchedInput.closest('[data-swatch-tooltip]');
        const swatchesContainer = container;
        if (swatchWrapper) {
        swatchWrapper.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
        } else {
        card.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
        }
        setTimeout(() => {
        matchedInput.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        matchedInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (swatchesContainer) {
            swatchesContainer.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
        }
        }, 300);
    });
}


document.addEventListener('DOMContentLoaded', () => {
    autoSelectColor();
    const resultsContainer = document.querySelector('[data-results-container]');
    if (resultsContainer) {
        const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
            setTimeout(autoSelectColor, 250);
            }
        }
        });
        observer.observe(resultsContainer, { childList: true });
    }
});
document.addEventListener('click', (e) => {
  const isColorFilter = e.target.closest('.filter-item[data-group="COLOR"]');
  if (isColorFilter) {
    setTimeout(autoSelectColor, 300);
  }
});